var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "m-radio",
    _vm._g(
      _vm._b(
        {
          attrs: { checked: _vm.selectedVal === _vm.value, name: _vm.name },
          on: {
            click: function($event) {
              return _vm.handleRadioClick(_vm.value)
            }
          }
        },
        "m-radio",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }